/* globalmodule */
/* homemodule */
define('../src/sublayouts/m31-search/m31-search',['jquery', 'slick', 'breakpoint', 'lib/utils'], function($, slick, breakpoint, utils) {

    'use strict';

    var M31_SEARCH = function($component) {

        this.$component = $component;
        return this;
    };

    /**
     * Initialise component
     */

    M31_SEARCH.prototype.init = function() {
        var _this = this,
            $input = _this.$component.find('.m31-search--input'),
            $searchBtn = _this.$component.find('.m31-search--button'),
            $searchMobBack = _this.$component.find('.m31-search--back');


        _this.setMobile();

        /* $input.on('keyup',function(){
             if ($input.val()) {
                 $(".m31-search--dm_close-word").show();
                 $(".m31-search--button").hide();
             }
             else {
                 $(".m31-search--dm_close-word").hide();
                 $(".m31-search--button").show();
             }
         })*/

        /* setTimeout(function() {
             if($input.val()){
                 _this.checkFocus(true);
                 _this.$component.find('.m31-search--tools-wrapper').show();
                 $(".m31-search--dm_close-word").show();
                 $(".m31-search--button").hide();
             }},400)*/


        // Backbutton only visible on small screens
        // when user click on back onFocusout() function trigger on page and backBtnMobile() function here
        // backBtnMobile() reset the UI by removing classes from parent of the search
        $searchMobBack.on('touchstart click', function(e) {
            _this.backBtnMobile();
        });

        $searchBtn.on('touchstart click', function(e) {
            _this.checkFocus(true);
        });

        $(window).on('orientationchange', $.proxy(this.setMobile, this));

        $(breakpoint).on('change', $.proxy(this.setMobile, this));

        if ($(window).outerWidth() >= 769) {
            _this.$component.removeClass('m31-search__mobile');
        }

        this.$component.find('.m31-search--expand').off('click.m31').on('click.m31', function() {
            if ($(window).outerWidth() >= 769) {
                $(this).hide();
                _this.checkFocus(true);
                _this.$component.find('.m31-search--tools-wrapper').fadeIn();
                _this.$component.find('.m31-search--input').focusin();
            }
        });

        // Close search when user click on document 
        // Only applicable on large screens, small screen close by button click
        $(document).off('click.m31close').on('click.m31close', function(event) {
            if (($(window).outerWidth() >= 769) && $(event.target).closest('.m31-search').length == 0 && _this.$component.find('.m31-search--input').val().length == 0 && _this.$component.hasClass('active')) {
                var $searchDoormat = _this.$component.find('.m31-search--doormat');
                if (!$searchDoormat.hasClass('active')) {
                    _this.$component.find('.m31-search--tools-wrapper').fadeOut();
                    setTimeout(function() {
                        _this.docClick(false);
                        _this.$component.find('.m31-search--expand').show();
                    }, 200)
                }
            };
        });

        // Trigger click search input on serch result page on load
        if (window.location.href.indexOf('term') > -1) {
            if ($(window).outerWidth() >= 769) {
                $('.m31-search--expand').click();
            } else {
                jQuery('.m31-search--button').trigger('touchstart')
            }
        }
    };

    M31_SEARCH.prototype.checkFocus = function(isFocus) {
        var _this = this,
            $input = _this.$component.find('.m31-search--input'),
            $m12ToolSearch = _this.$component.closest('.m12-tools__search'),
            $m12BarWrapper = _this.$component.closest('.m12-bar__wrapper'),
            $searchDoormat = _this.$component.find('.m31-search--doormat');

        if (isFocus || $searchDoormat.hasClass('active')) {
            _this.$component.addClass('active');
            $m12ToolSearch.addClass('search-active');
            if (_this.$component.hasClass('m31-search__icon--only') || _this.$component.hasClass('m31-search__mobile')) {
                $m12BarWrapper.addClass('search-active-wrapper');
                $input.focus()
            }
        } else {
            setTimeout(function() {
                _this.$component.removeClass('active');
                $m12ToolSearch.removeClass('search-active');
                $m12BarWrapper.removeClass('search-active-wrapper');
            }, 400)
            $input.val('');
        }
    };



    M31_SEARCH.prototype.setMobile = function() {
        var _this = this,
            dir = $('html').attr('dir') == "ltr" ? 'right' : 'left',
            $m12ToolSearch = _this.$component.closest('.m12-tools__search'),
            $input = _this.$component.find('.m31-search--input'),
            isFocus = false;

        if ($(window).outerWidth() < 769) {
            $m12ToolSearch.css(dir, (0) + 'px')
            _this.$component.addClass('m31-search__mobile');
        } else {
            $m12ToolSearch.css(dir, '')
            _this.$component.removeClass('m31-search__mobile');
        }


        /*if ($input.val() || $input.is(':focus') || _this.$component.hasClass('active')) {
            isFocus = true
        }
        _this.checkFocus(isFocus);*/
    };

    // Backbutton only visible on small screens
    // when user click on back onFocusout() function trigger on page and backBtnMobile() function here
    // backBtnMobile() reset the UI by removing classes from parent of the search
    M31_SEARCH.prototype.backBtnMobile = function() {
        var _this = this,
            $m12ToolSearch = _this.$component.closest('.m12-tools__search'),
            $m12BarWrapper = _this.$component.closest('.m12-bar__wrapper'),
            $searchDoormat = _this.$component.find('.m31-search--doormat');
        setTimeout(function() {
            // repeated function from onFocusout() on page
            $('#wrapper_loader').hide();
            // repeated function from onFocusout() on page
            $searchDoormat.removeClass('active');

            _this.$component.removeClass('active');
            $m12ToolSearch.removeClass('search-active');
            $m12BarWrapper.removeClass('search-active-wrapper');

            // repeated function from onFocusout() on page
            $(".m31-search--dm_close-word").hide();
            // repeated function from onFocusout() on page
            $(".m31-search--button").show();
        }, 400)
        $input.val('');
        $input.blur();
    }

    M31_SEARCH.prototype.docClick = function(isFocus) {
        var _this = this,
            $input = _this.$component.find('.m31-search--input'),
            $m12ToolSearch = _this.$component.closest('.m12-tools__search'),
            $m12BarWrapper = _this.$component.closest('.m12-bar__wrapper'),
            $searchDoormat = _this.$component.find('.m31-search--doormat');

        if (isFocus || $searchDoormat.hasClass('active')) {
            _this.$component.addClass('active');
            $m12ToolSearch.addClass('search-active');
            if (_this.$component.hasClass('m31-search__icon--only') || _this.$component.hasClass('m31-search__mobile')) {
                $m12BarWrapper.addClass('search-active-wrapper');
                $input.focus()
            }
        } else {
            setTimeout(function() {
                _this.$component.removeClass('active');
                $m12ToolSearch.removeClass('search-active');
                $m12BarWrapper.removeClass('search-active-wrapper');
            }, 400)
            $input.val('');
        }
    };

    return M31_SEARCH;
});
